/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import SubPage from 'material/structure/subpage/subpage';
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/users/deleteuser/deleteuser_styles';




/* ========== ~~~~~~~~~~ MODAL : EDIT USER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const DeleteUser =(props)=> {
    const handleDelete = () =>{
        props.deleteUser(props.userUUID, props.index);
        props.displayModal(false);
    };
    return(
        <SubPage name={`deleteuser`} klass={props.classes.deleteuser}>
            <Copy name={`deleteuser`}>
                <Title size={`medium`}>
                    <h2>Delete confirmation</h2>
                </Title>
                <BodyCopy>{`Are you sure you want to delete the user ${props.name} (${props.email})?`}</BodyCopy>
            </Copy>
            <CTAs name={`ctas`} >
                <Button type={`modal`} action={false} variant={`normal`} name={`cancel`} text={`Cancel`} />
                <Button type={'action'} action={handleDelete} variant={`delete`} name={`delete`} text={`Delete`} />
            </CTAs>
        </SubPage>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(DeleteUser);